/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyImpactByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyImpactByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalyImpactByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyImpactByCloudAccountWidgetConfiguration>): CostAnomalyImpactByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new CostAnomalyImpactByCloudAccountWidgetConfiguration(), model);
        CostAnomalyImpactByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyImpactByCloudAccountWidgetConfiguration>): CostAnomalyImpactByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return CostAnomalyImpactByCloudAccountWidgetConfiguration.newInstance(<CostAnomalyImpactByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyImpactByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalyImpactByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyImpactByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyImpactByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
